import { useQuery, useQueryClient } from "@tanstack/react-query";
import fetch from "logic/rest/FetchProvider";
import { qualifyUrl } from "util/URLUtils";
const configUrl = "/plugins/org.graylog.plugins.failure/config";
const overviewUrl = "/plugins/org.graylog.plugins.failure/failures/count";
export const FAILURE_PROCESSING_CONFIG_QUERY_KEY = ["failure-processing", "config"];
export const FAILURE_PROCESSING_OVERVIEW_QUERY_KEY = ["failure-processing", "overview"];
export const loadFailureProcessingConfig = () => fetch("GET", qualifyUrl(configUrl));
export const loadFailureProcessingOverview = () => fetch("GET", qualifyUrl(overviewUrl));
export const updateFailureProcessingConfig = (config) => fetch("PUT", qualifyUrl(configUrl), config);
export const useFailureProcessingConfig = () => {
  const queryClient = useQueryClient();
  const { data } = useQuery({
    queryKey: FAILURE_PROCESSING_CONFIG_QUERY_KEY,
    queryFn: loadFailureProcessingConfig
  });
  const update = (config) => updateFailureProcessingConfig(config).then((result) => {
    queryClient.invalidateQueries({ queryKey: FAILURE_PROCESSING_CONFIG_QUERY_KEY });
    return result;
  });
  return { data, updateFailureProcessingConfig: update };
};
export const useFailureProcessingOverview = () => useQuery({
  queryKey: FAILURE_PROCESSING_OVERVIEW_QUERY_KEY,
  queryFn: loadFailureProcessingOverview
});
